import React from 'react';

interface BackArrowIconProps {
    width?: string | number;
    height?: string | number;
    stroke?: string;
    strokeWidth?: number;
    className?: string;
}

const BackArrowIcon: React.FC<BackArrowIconProps> = ({
    width = '20',
    height = '20',
    stroke = 'currentColor',
    strokeWidth = 2,
    className
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
    );
};

export default BackArrowIcon;
